import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

const baseUrl = 'https://bb-finance.p.rapidapi.com';
const headers = {
    'x-rapidapi-host': 'bb-finance.p.rapidapi.com',
    'x-rapidapi-key': '35f0e8c68dmshcc1768d061f1c3dp1cbd3bjsne3777f68063f'
}

export const BBFinanceAPI = createApi({
    reducerPath: "BBFinance",
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder) => ({
        getMovers: builder.query({
            query: () => ({url: `/market/get-movers`, params: {id: 'nifty:ind', template: 'INDEX'}, headers: headers})
        }),
        getFull: builder.query({
            query: (ticker) => ({url: `/market/get-full`, params: {id: ticker}, headers: headers})
        }),
        getPriceChart: builder.query({
            query: ({ticker, interval}) => ({url: `/market/get-chart`, params: {id: ticker, interval: interval}, headers: headers})
        }),
        getStatistics: builder.query({
            query: (ticker) => ({url: `/stock/get-statistics`, params: {id: ticker, template: 'STOCK'}, headers: headers})
        }),
        getFinancials: builder.query({
            query: (ticker) => ({url: `/stock/get-financials`, params: {id: ticker, template: 'STOCK'}, headers: headers})
        })
    })
})

export const {useGetMoversQuery, useGetFullQuery, useGetPriceChartQuery, useGetStatisticsQuery, useGetFinancialsQuery} = BBFinanceAPI